<template>


  <div>
    <div class="grid">
      <div class="col-3" v-for="(almacen, i) of almacenes">
      <div class="card" :class="{ 'card-active': show==i }" style="border-bottom: 5px solid #1C95C2" @click="this.$router.push('/insumos/' + almacen.id)">
        <h1>&nbsp;</h1>
        <h5>{{almacen.name}}</h5>
      </div>
    </div>
    <div class="col-3" >
      <div class="card" style="border-bottom: 5px solid #7E57C2" @click="this.$router.push('/solicitud-insumos')">
        <h1>{{ solicitudes.filter((item)=>item.status=='PENDIENTE').length }}</h1>
        <h5>SOLIC. INSUMO PENDIENTES</h5>  
      </div>
    </div>

  </div>

  <div class="cards">
    <div class="grid"> 
      <OtiForOp v-if="show==1" v-for="order in orders.filter((order) => order.status == 1)" :key="order.id" :order="order" /> 
      <OtiForOp v-if="show==0" v-for="order in orders.filter((order) => order.status == 0)" :key="order.id" :order="order" /> 
      <OtiForOp v-if="show==2" v-for="order in orders.filter((order) => order.status == 2)" :key="order.id" :order="order" /> 
      <OtiForOp v-if="show==3" v-for="order in orders.filter((order) => order.status == 3)" :key="order.id" :order="order" /> 
    </div>
  </div>
  <!--
    <TabView ref="tabview1">
      <TabPanel header="EN PROCESO">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 1)" :key="order.id" :order="order" /> </div>
      </TabPanel>
      <TabPanel header="SIN INICIAR">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 0)" :key="order.id" :order="order" /> </div>
      </TabPanel>

      <TabPanel header="EN PAUSA">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 2)" :key="order.id" :order="order" /> </div>
      </TabPanel>
      <TabPanel header="EN CALIDAD">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 3)" :key="order.id" :order="order" /> </div>
      </TabPanel>
                  
    </TabView>
    -->

<!-- 
     
- <div class="">
    TABLA DE CONTROL
</div>

        <div class="mt-3">
          <div class="col-12">
            <OtiClock
              :order="order"
              :opGroup="opGroup"
            />
          </div>
        </div>
        <p>{{ order }}</p> 
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import OtiClock from "./../OtiClock.vue";
import CrudService from "./../../services/crud.service.js" 
import OtiForOp from "./OtiForOp.vue";

export default {
  props: ['opId', 'opGroup'],
  components: {
    OtiClock,
    OtiForOp
  },
  data() {
    return {
      orders: [],
      showPauseReportModal: false,
      show: 1,
      solicitudes: [],
      almacenes: [],
    };
  },
  computed: {
      values() {
          //return this.showPauseReportModal;
      }
  },
  created() {
    this.getOrders();
    CrudService.getCRUD('solicitud-insumos').then((data) => (this.solicitudes = data));
    CrudService.getCRUD('almacenes').then((data) => {
      this.almacenes = data
      this.almacenes = this.almacenes.filter((item)=>item.name!='INSUMOS VARIOS');
    });
    /*
    events.$on('operator-notify', data => {
      this.showPauseReportModal = true;
      console.log('Received...')
    });
    */
    
  },
  methods: {
    toSolic() {
      console.log('to solicitud-insumos')
    },
    toNuevo() {
      console.log('to new')
    },
    setTab(el) {
      this.show = el;
    },
    getOrders() {      
      CrudService.getCRUD("orden", "otibyuser/"+this.opId).then((data) => {
        this.orders = data;
        data.forEach((item) => {
          let user_id = item.current_operator;
          if (item.status==2 && item.logs) {
            console.log('item.logs')
            console.log(item.logs)
            console.log('item.logs[item.logs.length - 1]')
            console.log(item.logs[item.logs.length - 1])
            if (item.logs[item.logs.length - 1].status == 2 && item.logs[item.logs.length - 1].user_id != user_id) {
              this.showPauseReportModal = true;            
            }
          }
        });
      });

    },
  },
};
</script>

<style scoped lang="css">
  .cards {
    width: 100%;
  }

  .card {
    cursor: pointer;
  }

  .card-active {
    background-color: #91C7D1;
  }
  
</style>
